import { CalendarDays, Clock3, MoonStar, Plus } from "lucide-react";
import { describeSliderTime, formatJstDate, formatJstTime } from "../utils/sky";

type TimeScrubberProps = {
  dateValue: string;
  sliderMinutes: number;
  skyDate: Date;
  onDateChange: (date: string) => void;
  onSliderChange: (minutes: number) => void;
  onAdd: () => void;
};

export function TimeScrubber({
  dateValue,
  sliderMinutes,
  skyDate,
  onDateChange,
  onSliderChange,
  onAdd
}: TimeScrubberProps) {
  return (
    <footer className="time-scrubber" aria-label="星空の時刻">
      <div className="scrubber-readout">
        <MoonStar size={18} />
        <span>{formatJstDate(skyDate)}</span>
        <strong>{formatJstTime(skyDate)}</strong>
      </div>

      <label className="scrubber-date">
        <CalendarDays size={16} />
        <input type="date" value={dateValue} onChange={(event) => onDateChange(event.target.value)} />
      </label>

      <label className="scrubber-range">
        <span>18:00</span>
        <input
          type="range"
          min="0"
          max="720"
          step="10"
          value={sliderMinutes}
          onChange={(event) => onSliderChange(Number(event.target.value))}
        />
        <span>06:00</span>
      </label>

      <div className="scrubber-meta">
        <Clock3 size={15} />
        <span>{describeSliderTime(sliderMinutes)}</span>
      </div>

      <button type="button" className="scrubber-add" onClick={onAdd} aria-label="URLを追加">
        <Plus size={18} />
      </button>
    </footer>
  );
}
